

import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import { reactSelectStyles } from "./ReactSelectStyles";
import countryOptions from "../json/CountryCodes.json";

const FormPhoneInput = ({
  field = {},
  value = "",
  country_code = "+91",
  handleChange,
  error = null,
  placeholder = "Enter phone number",
  country_code_field = "country_dial_code",
}) => {
  // Format country list once
  const formattedCountries = useMemo(
    () =>
      countryOptions.map((country) => ({
        value: country.dial_code,
        label: `${country.name} (${country.dial_code})`,
      })),
    []
  );

  const [phoneNumber, setPhoneNumber] = useState(value);
  const [countryCode, setCountryCode] = useState(country_code);

  // Sync ONLY when parent updates values (API / edit form)
  useEffect(() => {
    setPhoneNumber(value || "");
  }, [value]);

  useEffect(() => {
    setCountryCode(country_code || "+91");
  }, [country_code]);

  // Phone number change (fires validation ONLY on user input)
  const handleNumberChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "");
    setPhoneNumber(digits);

    if (typeof handleChange === "function") {
      handleChange({
        target: {
          name: field?.name,
          value: digits,
        },
      });
    }
  };

  // Country code change (fires ONLY on user select)
  const handleCodeChange = (selected) => {
    const code = selected?.value || "+91";
    setCountryCode(code);

    if (typeof handleChange === "function") {
      handleChange({
        target: {
          name: country_code_field,
          value: code,
        },
      });
    }
  };

  const getStylesWithError = () => ({
    ...reactSelectStyles,
    control: (provided, state) => ({
      ...reactSelectStyles.control(provided, state),
      borderColor: error ? "#dc3545" : provided.borderColor,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      minHeight: "calc(2.4rem + 2px)",
      "&:hover": {
        borderColor: error ? "#dc3545" : "#86b7fe",
      },
    }),
  });

  return (
    <div className={field.fieldSize || "col-12"}>
      {field.label && (
        <label className="form-label text-muted mb-1">
          {field.label}
          {field.required && <span className="text-danger"> *</span>}
        </label>
      )}

      <div className="d-flex w-100">
        {/* Country Code Dropdown */}
        <div style={{ width: 160, zIndex: 5 }}>
          <Select
            options={formattedCountries}
            value={formattedCountries.find(
              (opt) => opt.value === countryCode
            )}
            onChange={handleCodeChange}
            styles={{ ...getStylesWithError(), menuPortal: (provided) => ({ ...provided, zIndex: 9999 }) }}
            isSearchable
            menuPortalTarget={
              typeof document !== "undefined" ? document.body : null
            }
          />
        </div>

        {/* Phone Input */}
        <input
          type="tel"
          value={phoneNumber}
          onChange={handleNumberChange}
          placeholder={placeholder}
          maxLength={15}
          className={`form-control ${error ? "is-invalid" : ""}`}
          style={{
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            minHeight: "calc(2.4rem + 2px)",
          }}
        />
      </div>

      {error && <small className="text-danger">{error}</small>}
    </div>
  );
};

FormPhoneInput.propTypes = {
  field: PropTypes.object,
  value: PropTypes.string,
  country_code: PropTypes.string,
  handleChange: PropTypes.func,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  country_code_field: PropTypes.string,
};

export default FormPhoneInput;